(function () {
    'use strict';

    class ReactComponentController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $element, $injector, $attrs, uuid4,  ReactLoaderService, $stateParams = {}) {
            super($scope, $injector);
            this.__objectType = 'ReactComponentController';
            this.$element = $element;

            this.$attrs = $attrs;
            this.$injector = $injector;
            this.$stateParams = $stateParams;
            this.reactRenderId = uuid4.generate();
            this.ReactLoaderService = ReactLoaderService;
        }

        $postLink() {
            const props = this.getProps();
        
            this.registerObservers(props);
            this.ReactLoaderService.getReactInstance().then(honeybookReact => {
                this.reactRenderFunction = honeybookReact.bootstrap(this.component);
                this.render(props);
            });
          }
        
          render(props, isPropUpdate) {
            const routeParams = { match: { params: Object.assign({}, this.$stateParams) } };

              if (!this.reactRenderFunction){
                return;
              }

              this.reactUnrenderFunction = this.reactRenderFunction(
                  this.$element[0],
                  this.reactRenderId,
                  props,
                  routeParams,
                  this.$injector,
                  isPropUpdate
              );

          }
        
          registerObservers(props) {
            Object.keys(props).forEach(propName => {
              this.$attrs.$observe(propName, () => {
                const props = this.getProps();

                this.render(props, true);
              });
            });
          }
        
          getProps() {
            return Object.keys(this.$attrs.$attr)
              .filter(key => key !== 'component')
              .reduce((result, key) => {
                result[key] = this.$attrs[key];
        
                return result;
              }, {});
          }
        
          $onDestroy() {
            this.reactUnrenderFunction && this.reactUnrenderFunction();
          }
        
    }

    Components.ReactComponent = {
        template: '<div></div>',
        bindings: {
          component: '@'
        },
        controller: ReactComponentController
    };

}());

